import { useGamesData } from "../hooks/useGamesData";
import Header from "../components/Header";
import Body from "../components/Body";
import PageScripts from "../components/PageScripts";

import "../assets/css/bootstrap.min.css";
import "../assets/css/plugins.css";
import "../assets/css/style.css";
import "../assets/css/coloring.css";
import "../assets/css/newstyle.css";
import "../assets/css/animate.min.css";
import "../assets/css/mobile.css";

const Home = () => {

  const { gamesData } = useGamesData();

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      <Header gamesData={gamesData} />

      <div id="wrapper">

        <div className="float-text show-on-scroll">
          <span>
            <a onClick={scrollToTop}>
              Scroll to top
            </a>
          </span>
        </div>

        <div className="scrollbar-v show-on-scroll"></div>

        <Body gamesData={gamesData} />

        <PageScripts />

      </div>
    </>
  );

};

export default Home;